export default {"src":"/_next/static/media/btn_appstore1.5b05a040.svg","height":50,"width":140,"blurWidth":0,"blurHeight":0};